export const terminalCheckoutForm = [
    {
        "acquirerName": "TRUELAYER"
    },
];